import { kijs, apiServiceHost } from '../config';
/*
 *	API calss used for KIJS api services
 * 	Example: api('search').get({q:'brīvības iela'}, callback);
 */
var api = function(optionsIn) {
	if (!(this instanceof api)) {
		return new api(optionsIn);
	}

	//add new api urls here
	this.apis_ = {
		search: 'v3/' + window.kijsKey + '/search',
		revGeo: 'v3/' + window.kijsKey + '/reverse_geocoding',
		getgeometry: 'v3/' + window.kijsKey + '/get_geometry?kijs=' + window.kijsKey + '&proj=4326', //hash=83f1bae0574fe8a41e0880dc6e50e2b4
		traffic: 'v3/' + window.kijsKey + '/trafficjam',
		speedcameras: 'v3/' + window.kijsKey + '/speedcameras'
		//"routingGDH":"routing/route/v1/driving/",
	};

	var options = {};

	if (typeof optionsIn === 'string') {
		options.api = optionsIn;
	} else if (typeof optionsIn === 'object') {
		options = _.extend(options, optionsIn);
	}

	this.activeURL = this.setUrl_(options.api);

	return this;
};

api.prototype.setUrl_ = function(strApi) {
	if (typeof this.apis_[strApi] != 'undefined') {
		const apiHost = strApi === 'routingGDH' ? gdhServiceHost : apiServiceHost;

		return apiHost + '/' + this.apis_[strApi]; //.replace('<KIJSPLACEHOLDER>',window.kijsKey);
	} else {
		console.log('Unknown api service');
	}
};

api.prototype.setUrlVals_ = function(strApi, objValues) {
	var strURL = strApi;

	var n = 0;
	for (var key in objValues) {
		if (objValues.hasOwnProperty(key)) {
			if (n === 0 && strURL.indexOf('?') === -1) {
				strURL += '?';
			} else {
				strURL += '&';
			}

			strURL += key + '=' + objValues[key];

			n++;
		}
	}

	return strURL;
};

api.prototype.remove = function(objKeyVals, callback) {
	//wip
};

api.prototype.put = function(objKeyVals, callback) {
	//wip
};

api.prototype.post = function(objKeyVals, callback) {
	//wip
};

api.prototype.promise = function(objKeyVals, fetchParams = {}) {
	return fetch(this.setUrlVals_(this.activeURL, objKeyVals), fetchParams);
};

api.prototype.get = function(objKeyVals, callback) {
	return fetch(this.setUrlVals_(this.activeURL, objKeyVals))
		.then(resp => {
			if (resp.status == 401) {
				fetch('/backend/public/v1/key')
					.then(response => response.json())
					.then(res => {
						window.kijsKey = res.key;
					});
				throw new Error('HTTP status ' + resp.status);
			} else {
				return resp.json();
			}
		})
		.then(data => {
			if (data && 'error' in data) {
			} else {
				callback(data);
			}
		});
};

export default api;
